// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Split buttons (and their drop-downs) require all sorts of custom styling.
  These buttons have IDs on them but we nest the rules beneath #rte-toolbar
  so that they have enough specificity to override the 'default' styles
  applied in editor-toolbar.less.
  */
.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color {
	border-right: 0;
	margin-right: 0;
	margin-left: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	padding: 0 3px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.selected-color,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.selected-color {
	background: var(--ds-background-input, #fff);
	border-radius: 2px;
	width: 12px;
	height: 2px;
	margin: 16px 0 0 1px;
	display: block;
	z-index: 10;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.selected-color
	span,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.selected-color
	span {
	width: 14px;
	height: 2px;
	margin: 0;
	padding: 0;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.icon-textcolor,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.icon-textcolor {
	margin-top: 2px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.aui-icon-small.aui-iconfont-editor-color:before,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	#rte-button-color
	.aui-icon-small.aui-iconfont-editor-color:before {
	font-size: 22px;
	content: '\\e90f';
	margin-left: -3px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton:hover,
#content.edit.adg3-editor #rte-toolbar li#color-picker-control.toolbar-splitbutton:hover {
	background-color: var(--ds-background-input-hovered, #fff);
	color: var(--ds-text-subtle, #405070);
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton:hover
	#rte-button-color
	span.icon.aui-iconfont-editor-color:before,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton:hover
	#rte-button-color
	span.icon.aui-iconfont-editor-color:before {
	color: var(--ds-icon-subtle, #405070);
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent
	> a.toolbar-trigger,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent
	> a.toolbar-trigger {
	width: 10px;
	margin-right: 1px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent
	> a.toolbar-trigger
	span,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent
	> a.toolbar-trigger
	span {
	width: 9px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent.dd-allocated,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent.dd-allocated {
	width: 10px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent.dd-allocated
	a#rte-button-color-selector.aui-dd-trigger,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent.dd-allocated
	a#rte-button-color-selector.aui-dd-trigger {
	padding: 0;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent.dd-allocated
	a#rte-button-color-selector.aui-dd-trigger:after,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.aui-dd-parent.dd-allocated
	a#rte-button-color-selector.aui-dd-trigger:after {
	margin-left: -9px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.color-picker-container,
#content.edit.adg3-editor
	#rte-toolbar
	li#color-picker-control.toolbar-splitbutton
	.color-picker-container {
	position: absolute;
	left: -18px;
	/* The table cell colour picker is a 'split button' with two clickable areas and needs some custom styling */
}

.editor-container.adg3-editor #rte-toolbar #rte-toolbar #table-highlight-group,
#content.edit.adg3-editor #rte-toolbar #table-highlight-group {
	/* So that this stays the same color as the toolbar after a user picks a cell highlight color */
	background-color: inherit;
	margin-right: 3px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	> .toolbar-splitbutton
	.aui-dd-parent
	a.toolbar-trigger
	.icon.icon-dropdown,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	> .toolbar-splitbutton
	.aui-dd-parent
	a.toolbar-trigger
	.icon.icon-dropdown {
	color: var(--ds-icon-inverse, #ffffff);
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	> button.aui-button:not([disabled])
	> .icon:before,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	> button.aui-button:not([disabled])
	> .icon:before {
	color: var(--ds-icon, #405070);
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour.disabled
	a.toolbar-trigger:after,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour.disabled
	a.toolbar-trigger:after {
	border-top-color: var(--ds-border, #405070);
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour.disabled
	.aui-dd-parent:hover,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour.disabled
	.aui-dd-parent:hover {
	background-color: var(--ds-background-input-hovered, #ffffff);
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent
	a.toolbar-trigger,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent
	a.toolbar-trigger,
.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent
	a.toolbar-trigger:hover,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent
	a.toolbar-trigger:hover,
.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent:hover,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group:hover
	.toolbar-splitbutton#table-highlight-colour
	.aui-dd-parent:hover {
	margin-right: 1;
}

.editor-container.adg3-editor #rte-toolbar #rte-toolbar #table-highlight-group .aui-button,
#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button {
	margin-right: 1px;
	/* Solving Firefox rendering issues to do with implicit icon heights and vertical-alignment */
	vertical-align: top;
}

.editor-container.adg3-editor #rte-toolbar #rte-toolbar #table-highlight-group .aui-button .icon,
#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button .icon {
	height: 20px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	.aui-button
	.icon:before,
#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button .icon:before {
	margin-top: -2px;
	/* End of solving Firefox rendering issues */
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	.aui-button
	.highlight-indicator,
#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button .highlight-indicator {
	position: absolute;
	padding: 0;
	width: 12px;
	height: 4px;
	margin: 16px 0 0 -13px;
	z-index: 2000;
	/* Groups the drop-down trigger with the drop-down contents */
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour,
#content.edit.adg3-editor #rte-toolbar #table-highlight-group #table-highlight-colour {
	float: none;
	width: 16px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	a.toolbar-trigger,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	a.toolbar-trigger {
	width: 15px;
	height: 24px;
	z-index: 0;
	box-shadow: none;
	/* CONFDEV-13971 */
	box-sizing: border-box;
	-moz-box-sizing: border-box;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	a.toolbar-trigger::after,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	a.toolbar-trigger::after {
	margin-left: -11px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	.aui-dd-parent,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	.aui-dd-parent {
	height: 24px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	.aui-dropdown,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	.aui-dropdown {
	overflow: auto;
	padding: 4px;
	width: 140px;
	min-width: 0;
	/* CONFDEV-8832 - On default sets a min-width of 150px - wtf! */
	left: -27px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker {
	list-style: none;
	margin: 0;
	padding: 0;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker
	li,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker
	li {
	display: inline;
	float: left;
	height: 16px;
	line-height: 16px;
	padding: 2px;
	width: 16px;
	margin-top: 4px;
}

.editor-container.adg3-editor
	#rte-toolbar
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker
	li
	a,
#content.edit.adg3-editor
	#rte-toolbar
	#table-highlight-group
	#table-highlight-colour
	ul.table-highlight-picker
	li
	a {
	border: 1px solid var(--ds-border-bold, #ccc);
	border-radius: 2px;
	display: block;
	height: 14px;
	line-height: 14px;
	padding: 0px;
	text-align: justify;
	width: 14px;
	/*
   These rules set the colours on the table cell highlight picker - kept flat for readability.
   Darker than the colours in the RTE, as the toolbar backgrounds are grey instead of white.
   We want the colours to be perceived the same.
   Calculation = 95% * brightness of the colour in RTE.
   */
	/* stylelint-disable design-system/ensure-design-token-usage */
}

#content.edit.adg3-editor #table-highlight-group .highlight-indicator {
	background-color: #dfe1e6;
}

html[data-color-mode='dark'] #content.edit.adg3-editor #table-highlight-group .highlight-indicator {
	background-color: #1a1c1f;
}

#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a {
	background-color: #f4f5f7;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a {
	background-color: #0a0b0d;
}

#content.edit.adg3-editor #table-highlight-group.highlight-blue .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-blue {
	background-color: var(--ds-background-accent-blue-subtlest, #e0f0ff);
}

#content.edit.adg3-editor #table-highlight-group.highlight-green .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-green {
	background-color: var(--ds-background-accent-green-subtlest, #ddfade);
}

#content.edit.adg3-editor #table-highlight-group.highlight-red .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-red {
	background-color: var(--ds-background-accent-red-subtlest, #ffe7e7);
}

#content.edit.adg3-editor #table-highlight-group.highlight-yellow .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-yellow {
	background-color: var(--ds-background-accent-yellow-subtlest, #ffffdd);
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#bf2600 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#bf2600 {
	background-color: #bf2600;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#bf2600
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#bf2600 {
	background-color: #f3572c;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#de350b .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#de350b {
	background-color: #de350b;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#de350b
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#de350b {
	background-color: #df360c;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff5630 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff5630 {
	background-color: #ff5630;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ff5630
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ff5630 {
	background-color: #be0f00;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff7452 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff7452 {
	background-color: #ff7452;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ff7452
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ff7452 {
	background-color: #a01f0a;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff8f73 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff8f73 {
	background-color: #ff8f73;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ff8f73
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ff8f73 {
	background-color: #812211;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffbdad .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffbdad {
	background-color: #ffbdad;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ffbdad
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ffbdad {
	background-color: #4d1d14;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffebe6 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffebe6 {
	background-color: #ffebe6;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ffebe6
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ffebe6 {
	background-color: #1e100a;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff8b00 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff8b00 {
	background-color: #ff8b00;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ff8b00
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ff8b00 {
	background-color: #882900;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff991f .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff991f {
	background-color: #ff991f;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ff991f
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ff991f {
	background-color: #782a00;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffab00 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffab00 {
	background-color: #ffab00;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ffab00
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ffab00 {
	background-color: #642900;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffc400 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffc400 {
	background-color: #ffc400;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ffc400
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ffc400 {
	background-color: #4b2500;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffe380 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffe380 {
	background-color: #ffe380;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ffe380
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ffe380 {
	background-color: #2d1800;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#fff0b3 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#fff0b3 {
	background-color: #fff0b3;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#fff0b3
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#fff0b3 {
	background-color: #1f1100;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#fffae6 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#fffae6 {
	background-color: #fffae6;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#fffae6
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#fffae6 {
	background-color: #0e0800;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#006644 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#006644 {
	background-color: #006644;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#006644
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#006644 {
	background-color: #52a57f;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#00875a .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00875a {
	background-color: #00875a;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#00875a
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#00875a {
	background-color: #03885b;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#36b37e .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#36b37e {
	background-color: #36b37e;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#36b37e
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#36b37e {
	background-color: #006235;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#57d9a3 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#57d9a3 {
	background-color: #57d9a3;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#57d9a3
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#57d9a3 {
	background-color: #004019;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#79f2c0 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#79f2c0 {
	background-color: #79f2c0;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#79f2c0
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#79f2c0 {
	background-color: #002c08;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#abf5d1 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#abf5d1 {
	background-color: #abf5d1;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#abf5d1
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#abf5d1 {
	background-color: #002307;
}

#content.edit.adg3-editor#table-highlight-group.highlight-\\#e3fcef .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#e3fcef {
	background-color: #e3fcef;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor#table-highlight-group.highlight-\\#e3fcef
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#e3fcef {
	background-color: #001102;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#008da6 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#008da6 {
	background-color: #008da6;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#008da6
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#008da6 {
	background-color: #007991;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#00a3bf .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00a3bf {
	background-color: #00a3bf;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#00a3bf
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#00a3bf {
	background-color: #006680;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#00b8d9 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00b8d9 {
	background-color: #00b8d9;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#00b8d9
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#00b8d9 {
	background-color: #005673;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#00c7e6 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00c7e6 {
	background-color: #00c7e6;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#00c7e6
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#00c7e6 {
	background-color: #004a66;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#79e2f2 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#79e2f2 {
	background-color: #79e2f2;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#79e2f2
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#79e2f2 {
	background-color: #003140;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#b3f5ff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#b3f5ff {
	background-color: #b3f5ff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#b3f5ff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#b3f5ff {
	background-color: #001d24;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#e6fcff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#e6fcff {
	background-color: #e6fcff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#e6fcff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#e6fcff {
	background-color: #001012;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#0747a6 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#0747a6 {
	background-color: #0747a6;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#0747a6
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#0747a6 {
	background-color: #899fff;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#0052cc .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#0052cc {
	background-color: #0052cc;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#0052cc
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#0052cc {
	background-color: #6c89ff;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#0065ff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#0065ff {
	background-color: #0065ff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#0065ff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#0065ff {
	background-color: #2e70ff;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#2684ff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#2684ff {
	background-color: #2684ff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#2684ff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#2684ff {
	background-color: #0066db;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#4c9aff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#4c9aff {
	background-color: #4c9aff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#4c9aff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#4c9aff {
	background-color: #0059b4;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#b3d4ff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#b3d4ff {
	background-color: #b3d4ff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#b3d4ff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#b3d4ff {
	background-color: #002a4b;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#deebff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#deebff {
	background-color: #deebff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#deebff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#deebff {
	background-color: #091624;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#403294 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#403294 {
	background-color: #403294;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#403294
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#403294 {
	background-color: #bb9fff;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#5243aa .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#5243aa {
	background-color: #5243aa;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#5243aa
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#5243aa {
	background-color: #a58cfe;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#6554c0 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#6554c0 {
	background-color: #6554c0;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#6554c0
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#6554c0 {
	background-color: #8d78e9;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#8777d9 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#8777d9 {
	background-color: #8777d9;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#8777d9
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#8777d9 {
	background-color: #6a5dbc;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#998dd9 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#998dd9 {
	background-color: #998dd9;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#998dd9
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#998dd9 {
	background-color: #585096;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#c0b6f2 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#c0b6f2 {
	background-color: #c0b6f2;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#c0b6f2
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#c0b6f2 {
	background-color: #353162;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#eae6ff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#eae6ff {
	background-color: #eae6ff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#eae6ff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#eae6ff {
	background-color: #171627;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#091e42 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#091e42 {
	background-color: #091e42;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#091e42
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#091e42 {
	background-color: #d1daff;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#172b4d .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#172b4d {
	background-color: #172b4d;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#172b4d
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#172b4d {
	background-color: #bdcbf7;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#253858 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#253858 {
	background-color: #253858;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#253858
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#253858 {
	background-color: #aebee6;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#344563 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#344563 {
	background-color: #344563;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#344563
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#344563 {
	background-color: #9eaed1;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#42526e .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#42526e {
	background-color: #42526e;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#42526e
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#42526e {
	background-color: #8f9ebe;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#505f79 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#505f79 {
	background-color: #505f79;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#505f79
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#505f79 {
	background-color: #8291ad;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#5e6c84 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#5e6c84 {
	background-color: #5e6c84;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#5e6c84
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#5e6c84 {
	background-color: #76849d;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#6b778c .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#6b778c {
	background-color: #6b778c;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#6b778c
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#6b778c {
	background-color: #6c788d;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#7a869a .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#7a869a {
	background-color: #7a869a;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#7a869a
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#7a869a {
	background-color: #5d697c;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#8993a4 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#8993a4 {
	background-color: #8993a4;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#8993a4
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#8993a4 {
	background-color: #535d6c;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#97a0af .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#97a0af {
	background-color: #97a0af;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#97a0af
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#97a0af {
	background-color: #48515e;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#a5adba .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#a5adba {
	background-color: #a5adba;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#a5adba
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#a5adba {
	background-color: #404752;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#b3bac5 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#b3bac5 {
	background-color: #b3bac5;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#b3bac5
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#b3bac5 {
	background-color: #363c45;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#c1c7d0 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#c1c7d0 {
	background-color: #c1c7d0;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#c1c7d0
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#c1c7d0 {
	background-color: #2c3138;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#dfe1e6 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#dfe1e6 {
	background-color: #dfe1e6;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#dfe1e6
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#dfe1e6 {
	background-color: #1a1c1f;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ebecf0 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ebecf0 {
	background-color: #ebecf0;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ebecf0
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ebecf0 {
	background-color: #151518;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#f4f5f7 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#f4f5f7 {
	background-color: #f4f5f7;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#f4f5f7
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#f4f5f7 {
	background-color: #0a0b0d;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#fafbfc .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#fafbfc {
	background-color: #fafbfc;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#fafbfc
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#fafbfc {
	background-color: #030405;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffffff .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffffff {
	background-color: #ffffff;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#ffffff
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#ffffff {
	background-color: #000000;
}

#content.edit.adg3-editor #table-highlight-group.highlight-\\#000000 .highlight-indicator,
#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#000000 {
	background-color: #000000;
}

html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group.highlight-\\#000000
	.highlight-indicator,
html[data-color-mode='dark']
	#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a.highlight-\\#000000 {
	background-color: #ffffff;
}

#content.edit.adg3-editor #table-highlight-group[data-remove-highlight='true'] .highlight-indicator,
#content.edit.adg3-editor
	#table-highlight-group
	.table-highlight-picker
	a[data-remove-highlight='true'] {
	background-color: transparent;
	/* stylelint-enable design-system/ensure-design-token-usage */
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/editor-toolbar-split-buttons.css"],"names":[],"mappings":"AAAA;;;;;GAKG;AACH;;;;;;;;;CASC,eAAe;CACf,eAAe;CACf,cAAc;CACd,0BAA0B;CAC1B,6BAA6B;CAC7B,cAAc;AACf;;AAEA;;;;;;;;;;;CAWC,4CAA4C;CAC5C,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,oBAAoB;CACpB,cAAc;CACd,WAAW;AACZ;;AAEA;;;;;;;;;;;;;CAaC,WAAW;CACX,WAAW;CACX,SAAS;CACT,UAAU;AACX;;AAEA;;;;;;;;;;;CAWC,eAAe;AAChB;;AAEA;;;;;;;;;;;CAWC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;;;;CAKC,0DAA0D;CAC1D,qCAAqC;AACtC;;AAEA;;;;;;;;;;;CAWC,qCAAqC;AACtC;;AAEA;;;;;;;;;;;CAWC,WAAW;CACX,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;CAaC,UAAU;AACX;;AAEA;;;;;;;;;CASC,WAAW;AACZ;;AAEA;;;;;;;;;;;CAWC,UAAU;AACX;;AAEA;;;;;;;;;;;CAWC,iBAAiB;AAClB;;AAEA;;;;;;;;;CASC,kBAAkB;CAClB,WAAW;CACX,4GAA4G;AAC7G;;AAEA;;CAEC,+FAA+F;CAC/F,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;CAeC,sCAAsC;AACvC;;AAEA;;;;;;;;;;;CAWC,8BAA8B;AAC/B;;AAEA;;;;;;;;;;;CAWC,2CAA2C;AAC5C;;AAEA;;;;;;;;;;;CAWC,6DAA6D;AAC9D;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAqCC,eAAe;AAChB;;AAEA;;CAEC,iBAAiB;CACjB,6FAA6F;CAC7F,mBAAmB;AACpB;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;;;;;CAOC,gBAAgB;CAChB,4CAA4C;AAC7C;;AAEA;;;;;;;CAOC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,WAAW;CACX,sBAAsB;CACtB,aAAa;CACb,6DAA6D;AAC9D;;AAEA;;;;;;CAMC,WAAW;CACX,WAAW;AACZ;;AAEA;;;;;;;;;;;CAWC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;;;;;;;;;;;CAWC,kBAAkB;AACnB;;AAEA;;;;;;;;;;;CAWC,YAAY;AACb;;AAEA;;;;;;;;;;;CAWC,cAAc;CACd,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,+DAA+D;CAC/D,WAAW;AACZ;;AAEA;;;;;;;;;;;CAWC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;;;;;;;;;;;;;CAaC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;;AAEA;;;;;;;;;;;;;;;CAeC,6CAA6C;CAC7C,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX;;;;;IAKG;CACH,8DAA8D;AAC/D;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;;CAKC,yBAAyB;AAC1B;;AAEA;;CAEC,oEAAoE;AACrE;;AAEA;;CAEC,qEAAqE;AACtE;;AAEA;;CAEC,mEAAmE;AACpE;;AAEA;;CAEC,sEAAsE;AACvE;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;CAQC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;AAC1B;;AAEA;;;;;CAKC,6BAA6B;CAC7B,6DAA6D;AAC9D","sourcesContent":["/*\n  Split buttons (and their drop-downs) require all sorts of custom styling.\n  These buttons have IDs on them but we nest the rules beneath #rte-toolbar\n  so that they have enough specificity to override the 'default' styles\n  applied in editor-toolbar.less.\n  */\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color {\n\tborder-right: 0;\n\tmargin-right: 0;\n\tmargin-left: 0;\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n\tpadding: 0 3px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.selected-color,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.selected-color {\n\tbackground: var(--ds-background-input, #fff);\n\tborder-radius: 2px;\n\twidth: 12px;\n\theight: 2px;\n\tmargin: 16px 0 0 1px;\n\tdisplay: block;\n\tz-index: 10;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.selected-color\n\tspan,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.selected-color\n\tspan {\n\twidth: 14px;\n\theight: 2px;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.icon-textcolor,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.icon-textcolor {\n\tmargin-top: 2px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.aui-icon-small.aui-iconfont-editor-color:before,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t#rte-button-color\n\t.aui-icon-small.aui-iconfont-editor-color:before {\n\tfont-size: 22px;\n\tcontent: '\\e90f';\n\tmargin-left: -3px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton:hover,\n#content.edit.adg3-editor #rte-toolbar li#color-picker-control.toolbar-splitbutton:hover {\n\tbackground-color: var(--ds-background-input-hovered, #fff);\n\tcolor: var(--ds-text-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t#rte-button-color\n\tspan.icon.aui-iconfont-editor-color:before,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton:hover\n\t#rte-button-color\n\tspan.icon.aui-iconfont-editor-color:before {\n\tcolor: var(--ds-icon-subtle, #405070);\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent\n\t> a.toolbar-trigger,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent\n\t> a.toolbar-trigger {\n\twidth: 10px;\n\tmargin-right: 1px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent\n\t> a.toolbar-trigger\n\tspan,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent\n\t> a.toolbar-trigger\n\tspan {\n\twidth: 9px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent.dd-allocated,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent.dd-allocated {\n\twidth: 10px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent.dd-allocated\n\ta#rte-button-color-selector.aui-dd-trigger,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent.dd-allocated\n\ta#rte-button-color-selector.aui-dd-trigger {\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent.dd-allocated\n\ta#rte-button-color-selector.aui-dd-trigger:after,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.aui-dd-parent.dd-allocated\n\ta#rte-button-color-selector.aui-dd-trigger:after {\n\tmargin-left: -9px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.color-picker-container,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\tli#color-picker-control.toolbar-splitbutton\n\t.color-picker-container {\n\tposition: absolute;\n\tleft: -18px;\n\t/* The table cell colour picker is a 'split button' with two clickable areas and needs some custom styling */\n}\n\n.editor-container.adg3-editor #rte-toolbar #rte-toolbar #table-highlight-group,\n#content.edit.adg3-editor #rte-toolbar #table-highlight-group {\n\t/* So that this stays the same color as the toolbar after a user picks a cell highlight color */\n\tbackground-color: inherit;\n\tmargin-right: 3px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t> .toolbar-splitbutton\n\t.aui-dd-parent\n\ta.toolbar-trigger\n\t.icon.icon-dropdown,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t> .toolbar-splitbutton\n\t.aui-dd-parent\n\ta.toolbar-trigger\n\t.icon.icon-dropdown {\n\tcolor: var(--ds-icon-inverse, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t> button.aui-button:not([disabled])\n\t> .icon:before,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t> button.aui-button:not([disabled])\n\t> .icon:before {\n\tcolor: var(--ds-icon, #405070);\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour.disabled\n\ta.toolbar-trigger:after,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour.disabled\n\ta.toolbar-trigger:after {\n\tborder-top-color: var(--ds-border, #405070);\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour.disabled\n\t.aui-dd-parent:hover,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour.disabled\n\t.aui-dd-parent:hover {\n\tbackground-color: var(--ds-background-input-hovered, #ffffff);\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent\n\ta.toolbar-trigger,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent\n\ta.toolbar-trigger,\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent\n\ta.toolbar-trigger:hover,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent\n\ta.toolbar-trigger:hover,\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent:hover,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group:hover\n\t.toolbar-splitbutton#table-highlight-colour\n\t.aui-dd-parent:hover {\n\tmargin-right: 1;\n}\n\n.editor-container.adg3-editor #rte-toolbar #rte-toolbar #table-highlight-group .aui-button,\n#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button {\n\tmargin-right: 1px;\n\t/* Solving Firefox rendering issues to do with implicit icon heights and vertical-alignment */\n\tvertical-align: top;\n}\n\n.editor-container.adg3-editor #rte-toolbar #rte-toolbar #table-highlight-group .aui-button .icon,\n#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button .icon {\n\theight: 20px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t.aui-button\n\t.icon:before,\n#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button .icon:before {\n\tmargin-top: -2px;\n\t/* End of solving Firefox rendering issues */\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t.aui-button\n\t.highlight-indicator,\n#content.edit.adg3-editor #rte-toolbar #table-highlight-group .aui-button .highlight-indicator {\n\tposition: absolute;\n\tpadding: 0;\n\twidth: 12px;\n\theight: 4px;\n\tmargin: 16px 0 0 -13px;\n\tz-index: 2000;\n\t/* Groups the drop-down trigger with the drop-down contents */\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour,\n#content.edit.adg3-editor #rte-toolbar #table-highlight-group #table-highlight-colour {\n\tfloat: none;\n\twidth: 16px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\ta.toolbar-trigger,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\ta.toolbar-trigger {\n\twidth: 15px;\n\theight: 24px;\n\tz-index: 0;\n\tbox-shadow: none;\n\t/* CONFDEV-13971 */\n\tbox-sizing: border-box;\n\t-moz-box-sizing: border-box;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\ta.toolbar-trigger::after,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\ta.toolbar-trigger::after {\n\tmargin-left: -11px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\t.aui-dd-parent,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\t.aui-dd-parent {\n\theight: 24px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\t.aui-dropdown,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\t.aui-dropdown {\n\toverflow: auto;\n\tpadding: 4px;\n\twidth: 140px;\n\tmin-width: 0;\n\t/* CONFDEV-8832 - On default sets a min-width of 150px - wtf! */\n\tleft: -27px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker\n\tli,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker\n\tli {\n\tdisplay: inline;\n\tfloat: left;\n\theight: 16px;\n\tline-height: 16px;\n\tpadding: 2px;\n\twidth: 16px;\n\tmargin-top: 4px;\n}\n\n.editor-container.adg3-editor\n\t#rte-toolbar\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker\n\tli\n\ta,\n#content.edit.adg3-editor\n\t#rte-toolbar\n\t#table-highlight-group\n\t#table-highlight-colour\n\tul.table-highlight-picker\n\tli\n\ta {\n\tborder: 1px solid var(--ds-border-bold, #ccc);\n\tborder-radius: 2px;\n\tdisplay: block;\n\theight: 14px;\n\tline-height: 14px;\n\tpadding: 0px;\n\ttext-align: justify;\n\twidth: 14px;\n\t/*\n   These rules set the colours on the table cell highlight picker - kept flat for readability.\n   Darker than the colours in the RTE, as the toolbar backgrounds are grey instead of white.\n   We want the colours to be perceived the same.\n   Calculation = 95% * brightness of the colour in RTE.\n   */\n\t/* stylelint-disable design-system/ensure-design-token-usage */\n}\n\n#content.edit.adg3-editor #table-highlight-group .highlight-indicator {\n\tbackground-color: #dfe1e6;\n}\n\nhtml[data-color-mode='dark'] #content.edit.adg3-editor #table-highlight-group .highlight-indicator {\n\tbackground-color: #1a1c1f;\n}\n\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a {\n\tbackground-color: #f4f5f7;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta {\n\tbackground-color: #0a0b0d;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-blue .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-blue {\n\tbackground-color: var(--ds-background-accent-blue-subtlest, #e0f0ff);\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-green .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-green {\n\tbackground-color: var(--ds-background-accent-green-subtlest, #ddfade);\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-red .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-red {\n\tbackground-color: var(--ds-background-accent-red-subtlest, #ffe7e7);\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-yellow .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-yellow {\n\tbackground-color: var(--ds-background-accent-yellow-subtlest, #ffffdd);\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#bf2600 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#bf2600 {\n\tbackground-color: #bf2600;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#bf2600\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#bf2600 {\n\tbackground-color: #f3572c;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#de350b .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#de350b {\n\tbackground-color: #de350b;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#de350b\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#de350b {\n\tbackground-color: #df360c;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff5630 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff5630 {\n\tbackground-color: #ff5630;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ff5630\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ff5630 {\n\tbackground-color: #be0f00;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff7452 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff7452 {\n\tbackground-color: #ff7452;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ff7452\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ff7452 {\n\tbackground-color: #a01f0a;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff8f73 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff8f73 {\n\tbackground-color: #ff8f73;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ff8f73\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ff8f73 {\n\tbackground-color: #812211;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffbdad .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffbdad {\n\tbackground-color: #ffbdad;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ffbdad\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ffbdad {\n\tbackground-color: #4d1d14;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffebe6 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffebe6 {\n\tbackground-color: #ffebe6;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ffebe6\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ffebe6 {\n\tbackground-color: #1e100a;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff8b00 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff8b00 {\n\tbackground-color: #ff8b00;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ff8b00\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ff8b00 {\n\tbackground-color: #882900;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ff991f .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ff991f {\n\tbackground-color: #ff991f;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ff991f\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ff991f {\n\tbackground-color: #782a00;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffab00 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffab00 {\n\tbackground-color: #ffab00;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ffab00\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ffab00 {\n\tbackground-color: #642900;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffc400 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffc400 {\n\tbackground-color: #ffc400;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ffc400\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ffc400 {\n\tbackground-color: #4b2500;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffe380 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffe380 {\n\tbackground-color: #ffe380;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ffe380\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ffe380 {\n\tbackground-color: #2d1800;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#fff0b3 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#fff0b3 {\n\tbackground-color: #fff0b3;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#fff0b3\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#fff0b3 {\n\tbackground-color: #1f1100;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#fffae6 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#fffae6 {\n\tbackground-color: #fffae6;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#fffae6\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#fffae6 {\n\tbackground-color: #0e0800;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#006644 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#006644 {\n\tbackground-color: #006644;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#006644\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#006644 {\n\tbackground-color: #52a57f;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#00875a .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00875a {\n\tbackground-color: #00875a;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#00875a\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#00875a {\n\tbackground-color: #03885b;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#36b37e .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#36b37e {\n\tbackground-color: #36b37e;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#36b37e\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#36b37e {\n\tbackground-color: #006235;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#57d9a3 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#57d9a3 {\n\tbackground-color: #57d9a3;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#57d9a3\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#57d9a3 {\n\tbackground-color: #004019;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#79f2c0 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#79f2c0 {\n\tbackground-color: #79f2c0;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#79f2c0\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#79f2c0 {\n\tbackground-color: #002c08;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#abf5d1 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#abf5d1 {\n\tbackground-color: #abf5d1;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#abf5d1\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#abf5d1 {\n\tbackground-color: #002307;\n}\n\n#content.edit.adg3-editor#table-highlight-group.highlight-\\#e3fcef .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#e3fcef {\n\tbackground-color: #e3fcef;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor#table-highlight-group.highlight-\\#e3fcef\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#e3fcef {\n\tbackground-color: #001102;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#008da6 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#008da6 {\n\tbackground-color: #008da6;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#008da6\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#008da6 {\n\tbackground-color: #007991;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#00a3bf .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00a3bf {\n\tbackground-color: #00a3bf;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#00a3bf\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#00a3bf {\n\tbackground-color: #006680;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#00b8d9 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00b8d9 {\n\tbackground-color: #00b8d9;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#00b8d9\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#00b8d9 {\n\tbackground-color: #005673;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#00c7e6 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#00c7e6 {\n\tbackground-color: #00c7e6;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#00c7e6\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#00c7e6 {\n\tbackground-color: #004a66;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#79e2f2 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#79e2f2 {\n\tbackground-color: #79e2f2;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#79e2f2\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#79e2f2 {\n\tbackground-color: #003140;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#b3f5ff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#b3f5ff {\n\tbackground-color: #b3f5ff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#b3f5ff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#b3f5ff {\n\tbackground-color: #001d24;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#e6fcff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#e6fcff {\n\tbackground-color: #e6fcff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#e6fcff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#e6fcff {\n\tbackground-color: #001012;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#0747a6 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#0747a6 {\n\tbackground-color: #0747a6;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#0747a6\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#0747a6 {\n\tbackground-color: #899fff;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#0052cc .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#0052cc {\n\tbackground-color: #0052cc;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#0052cc\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#0052cc {\n\tbackground-color: #6c89ff;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#0065ff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#0065ff {\n\tbackground-color: #0065ff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#0065ff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#0065ff {\n\tbackground-color: #2e70ff;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#2684ff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#2684ff {\n\tbackground-color: #2684ff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#2684ff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#2684ff {\n\tbackground-color: #0066db;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#4c9aff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#4c9aff {\n\tbackground-color: #4c9aff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#4c9aff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#4c9aff {\n\tbackground-color: #0059b4;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#b3d4ff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#b3d4ff {\n\tbackground-color: #b3d4ff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#b3d4ff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#b3d4ff {\n\tbackground-color: #002a4b;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#deebff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#deebff {\n\tbackground-color: #deebff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#deebff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#deebff {\n\tbackground-color: #091624;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#403294 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#403294 {\n\tbackground-color: #403294;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#403294\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#403294 {\n\tbackground-color: #bb9fff;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#5243aa .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#5243aa {\n\tbackground-color: #5243aa;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#5243aa\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#5243aa {\n\tbackground-color: #a58cfe;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#6554c0 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#6554c0 {\n\tbackground-color: #6554c0;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#6554c0\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#6554c0 {\n\tbackground-color: #8d78e9;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#8777d9 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#8777d9 {\n\tbackground-color: #8777d9;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#8777d9\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#8777d9 {\n\tbackground-color: #6a5dbc;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#998dd9 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#998dd9 {\n\tbackground-color: #998dd9;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#998dd9\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#998dd9 {\n\tbackground-color: #585096;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#c0b6f2 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#c0b6f2 {\n\tbackground-color: #c0b6f2;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#c0b6f2\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#c0b6f2 {\n\tbackground-color: #353162;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#eae6ff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#eae6ff {\n\tbackground-color: #eae6ff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#eae6ff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#eae6ff {\n\tbackground-color: #171627;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#091e42 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#091e42 {\n\tbackground-color: #091e42;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#091e42\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#091e42 {\n\tbackground-color: #d1daff;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#172b4d .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#172b4d {\n\tbackground-color: #172b4d;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#172b4d\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#172b4d {\n\tbackground-color: #bdcbf7;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#253858 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#253858 {\n\tbackground-color: #253858;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#253858\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#253858 {\n\tbackground-color: #aebee6;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#344563 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#344563 {\n\tbackground-color: #344563;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#344563\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#344563 {\n\tbackground-color: #9eaed1;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#42526e .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#42526e {\n\tbackground-color: #42526e;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#42526e\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#42526e {\n\tbackground-color: #8f9ebe;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#505f79 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#505f79 {\n\tbackground-color: #505f79;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#505f79\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#505f79 {\n\tbackground-color: #8291ad;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#5e6c84 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#5e6c84 {\n\tbackground-color: #5e6c84;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#5e6c84\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#5e6c84 {\n\tbackground-color: #76849d;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#6b778c .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#6b778c {\n\tbackground-color: #6b778c;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#6b778c\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#6b778c {\n\tbackground-color: #6c788d;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#7a869a .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#7a869a {\n\tbackground-color: #7a869a;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#7a869a\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#7a869a {\n\tbackground-color: #5d697c;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#8993a4 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#8993a4 {\n\tbackground-color: #8993a4;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#8993a4\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#8993a4 {\n\tbackground-color: #535d6c;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#97a0af .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#97a0af {\n\tbackground-color: #97a0af;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#97a0af\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#97a0af {\n\tbackground-color: #48515e;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#a5adba .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#a5adba {\n\tbackground-color: #a5adba;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#a5adba\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#a5adba {\n\tbackground-color: #404752;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#b3bac5 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#b3bac5 {\n\tbackground-color: #b3bac5;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#b3bac5\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#b3bac5 {\n\tbackground-color: #363c45;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#c1c7d0 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#c1c7d0 {\n\tbackground-color: #c1c7d0;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#c1c7d0\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#c1c7d0 {\n\tbackground-color: #2c3138;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#dfe1e6 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#dfe1e6 {\n\tbackground-color: #dfe1e6;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#dfe1e6\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#dfe1e6 {\n\tbackground-color: #1a1c1f;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ebecf0 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ebecf0 {\n\tbackground-color: #ebecf0;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ebecf0\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ebecf0 {\n\tbackground-color: #151518;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#f4f5f7 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#f4f5f7 {\n\tbackground-color: #f4f5f7;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#f4f5f7\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#f4f5f7 {\n\tbackground-color: #0a0b0d;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#fafbfc .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#fafbfc {\n\tbackground-color: #fafbfc;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#fafbfc\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#fafbfc {\n\tbackground-color: #030405;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#ffffff .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#ffffff {\n\tbackground-color: #ffffff;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#ffffff\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#ffffff {\n\tbackground-color: #000000;\n}\n\n#content.edit.adg3-editor #table-highlight-group.highlight-\\#000000 .highlight-indicator,\n#content.edit.adg3-editor #table-highlight-group .table-highlight-picker a.highlight-\\#000000 {\n\tbackground-color: #000000;\n}\n\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group.highlight-\\#000000\n\t.highlight-indicator,\nhtml[data-color-mode='dark']\n\t#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta.highlight-\\#000000 {\n\tbackground-color: #ffffff;\n}\n\n#content.edit.adg3-editor #table-highlight-group[data-remove-highlight='true'] .highlight-indicator,\n#content.edit.adg3-editor\n\t#table-highlight-group\n\t.table-highlight-picker\n\ta[data-remove-highlight='true'] {\n\tbackground-color: transparent;\n\t/* stylelint-enable design-system/ensure-design-token-usage */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
